/* Mae & Mini visual viewport variables.
   iOS Chrome/Safari animate their browser bars independently from the layout
   viewport. Fixed bottom UI uses these vars to stay above the visible edge. */
(function () {
  'use strict';

  var doc = document.documentElement;
  var raf = 0;
  var previous = {};

  function px(value) {
    value = Number(value) || 0;
    if (value < 0.5) value = 0;
    return Math.round(value * 100) / 100 + 'px';
  }

  function setViewportVars() {
    raf = 0;

    var vv = window.visualViewport;
    var layoutHeight = window.innerHeight || doc.clientHeight || 0;
    var layoutWidth = window.innerWidth || doc.clientWidth || 0;
    var width = layoutWidth;
    var height = layoutHeight;
    var top = 0;
    var bottom = 0;

    if (vv) {
      width = vv.width || width;
      height = vv.height || height;
      top = vv.offsetTop || 0;
      bottom = layoutHeight - height - top;
    }

    setVariable('--mm-vvw', width);
    setVariable('--mm-vvh', height);
    setVariable('--mm-vv-top', top);
    setVariable('--mm-vv-bottom', bottom);
  }

  function setVariable(name, value) {
    var next = px(value);
    if (previous[name] === next) return;
    previous[name] = next;
    doc.style.setProperty(name, next);
  }

  function schedule() {
    if (raf) return;
    raf = window.requestAnimationFrame(setViewportVars);
  }

  setViewportVars();

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule, { passive: true });
    window.visualViewport.addEventListener('scroll', schedule, { passive: true });
  }

  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule, { passive: true });
  window.addEventListener('pageshow', schedule, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  }
})();
